import { FormControlLabel, Switch as MUISwitch } from "@mui/material";
import { FC } from "react";
import { SwitchPropsType } from "./Switch.types";
const Switch: FC<SwitchPropsType> = ({
  label = "",
  onChange = () => {},
  checked,
  name = "",
  className = "",
  params,
  disabled,
  defaultChecked,
}) => {
  return (
    <FormControlLabel
      className={className}
      control={
        <MUISwitch
          checked={checked}
          onChange={onChange}
          name={name}
          defaultChecked={defaultChecked}
          {...params}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
};

export default Switch;
